import axios from 'axios';
import Authenticator from '../authenticator';
import { useEffect, useState } from 'react';
import { Form, Button, Card, Col, Row, CardHeader, CardBody } from 'react-bootstrap';
import Loading from '../components/loading';
import ErrorMessage from '../components/errorMessage';
import SuccessMessage from '../components/successMessage';
import api from '../api/api';
import { useNavigate } from 'react-router-dom';

export default function UserRegistration() {

  const navigate = useNavigate();

  const [selectedClientId, setSelectedClientId] = useState(null);
  const [clients, setClients] = useState([]);
  const [userName, setUserName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');


  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = () => {
    setIsLoading(true);
    api.get('/clients', {
      headers: { Authorization: sessionStorage.getItem('token') }
    }).then((returnFromApi) => {
      setClients(returnFromApi.data);
      setIsLoading(false);
    }).catch((error) => {
      console.error(error);
      setIsLoading(false);
    });
  };

  const registerUser = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setShowSuccessMessage(false);
    setShowErrorMessage(false);

    const dataToSend = {
      name: userName,
      clientId: selectedClientId
    };

    api.post('/users', dataToSend, {
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then((returnFromApi) => {
      setShowSuccessMessage(true);
      setSuccessMessage(returnFromApi.data);
      setUserName('');
      setIsLoading(false);
    }).catch((error) => {
      console.error(error);
      setIsLoading(false);
    });;
  };

  const goToClientList = () => {
    navigate("/client-list");
  };
  return (
    <Card className="bg-transparent-50 overflow-hidden" style={{ minHeight: '250px' }}>
      <Authenticator />
      <CardHeader className="position-relative">
        <div className="row flex-between-center">
          <div className="col col-lg-8">
            <h5 className="mb-0 texto-negrito">Cadastro de Usuário</h5>
          </div>
        </div>
      </CardHeader>

      <CardBody>
        {showSuccessMessage && <SuccessMessage message={successMessage} setShow={setShowSuccessMessage} />}
        {showErrorMessage && <ErrorMessage message={errorMessage} setShow={setShowErrorMessage} />}

        <Loading isToHidden={!isLoading} />

        <Form onSubmit={registerUser} hidden={isLoading}>
          <Row>
            <Col xs={6}>
              <Form.Group className="mb-3" controlId="clientId">
                <Form.Label className="fs-9">Cliente</Form.Label>

                <Form.Select
                  value={selectedClientId}
                  onChange={(e) => setSelectedClientId(e.target.value)}
                  required
                >
                  <option value="">Selecione um cliente...</option>

                  {clients.map((client) => (
                    <option key={client.id} value={client.id}>
                      {client.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col xs={6}>
              <Form.Group className="mb-3" controlId="clientName">
                <Form.Label className="fs-9">Nome</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Informe o nome"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="d-flex justify-content-end gap-2">
            <Button
              variant="outline-secondary"
              onClick={goToClientList}>
              Voltar para listagem
            </Button>
            <Button type="submit" disabled={isLoading}>
              Salvar
            </Button>
          </div>
        </Form>
      </CardBody>
    </Card>
  );
}
